module.exports = __webpack_public_path__ + "img/austria-ovarian-cancer-female.72c4ee59.png";